import { render, staticRenderFns } from "./KeyTwelve.vue?vue&type=template&id=3c89e213&scoped=true&"
import script from "./KeyTwelve.vue?vue&type=script&lang=js&"
export * from "./KeyTwelve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c89e213",
  null
  
)

export default component.exports